import React from 'react';
import { 
  HelpCircle, 
  DollarSign, 
  TrendingUp, 
  ShieldCheck, 
  Wallet, 
  BookOpen, 
  Target
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: DollarSign,
      title: 'Увеличьте норму сбережений',
      description: 'Старайтесь откладывать минимум 15-20% дохода для достижения финансовой независимости.'
    },
    {
      icon: TrendingUp,
      title: 'Регулярно инвестируйте',
      description: 'Инвестируйте деньги каждый месяц, независимо от ситуации на рынке.'
    },
    {
      icon: ShieldCheck,
      title: 'Диверсифицируйте активы',
      description: 'Распределяйте инвестиции между разными классами активов для снижения рисков.'
    },
    {
      icon: Wallet,
      title: 'Используйте налоговые льготы',
      description: 'ИИС и НПФ позволяют получить налоговые вычеты, ускоряя путь к цели.'
    },
    {
      icon: Target,
      title: 'Начните с финансовой подушки',
      description: 'Сначала создайте резервный фонд на 3-6 месяцев расходов.'
    },
    {
      icon: BookOpen,
      title: 'Повышайте финансовую грамотность',
      description: 'Постоянно обучайтесь основам инвестирования и финансового планирования.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по финансовой независимости
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <BookOpen className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Правило 4%
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              Согласно исследованиям, можно безопасно тратить около 4% от накопленного капитала ежегодно без риска его исчерпания. Это правило помогает рассчитать необходимую сумму накоплений.
            </p>
            <div className="text-xs text-green-800 dark:text-green-300 font-medium">
              Формула: Годовые расходы × 25 = Необходимый капитал
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;